import React from 'react';
import { Dialog, DialogContent, makeStyles } from '@material-ui/core';
import SuccessModalCheckIcon from '../../assets/images/SuccessModalCheckIcon.svg';
import { useSelector, useDispatch } from 'react-redux';
import {
	toggleSuccessModal,
	setSuccessMessage,
} from '../../reducers/UiReducer';
import TitleText from './TitleText';
import BodyText from './BodyText';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		backdropFilter: 'blur(2px)',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(3),
		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(2.5),
		},
		color: theme.palette.grey[500],
	},
}));

const SuccessModal = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { successModal, successMessage } = useSelector((state) => state.ui);
	const handleClose = () => {
		dispatch(toggleSuccessModal(false));
		dispatch(setSuccessMessage(''));
	};
	return (
		<Dialog
			PaperProps={{
				style: {
					borderRadius: 20,
				},
			}}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			className={classes.root}
			open={successModal}
			fullWidth={true}
			maxWidth={'xs'}>
			<DialogContent
				style={{
					paddingBottom: 20,
					paddingTop: 50,
				}}>
				<TitleText two textStyle={{ fontWeight: 700, textAlign: 'center' }}>
					Successfully Done
				</TitleText>
				<BodyText
					two
					textStyle={{ fontWeight: 500, textAlign: 'center', marginTop: 20 }}>
					{successMessage}
				</BodyText>
			</DialogContent>
			<img
				src={SuccessModalCheckIcon}
				alt='success-modal-icon'
				style={{
					position: 'fixed',
					left: '50%',
					transform: 'translate(-50%, -50%)',
				}}
			/>
		</Dialog>
	);
};

export default SuccessModal;
